<div class="nav">
    <div class="nav-top">
        <!-- <img class="back-icon" alt="Back Logo" src="/assets/images/back_icon.svg" /> -->
        <div class="img-logo">
            <img alt="MyLion Logo" src="/assets/images/lionsclub_logo.png" />
        </div>
    </div>
</div>